import { atom } from 'infrastructure/state/jotai.wrapper'
import {
  filteredSourceFilesAtom,
  ingestedFilesAtom,
} from '../../components/ingestion/atoms'
import { AwsContentItem } from 'shared/types/ingestion'
import { objectFieldSort } from '../../utility'
import { IMCourse } from './types'

export type PairedFile = {
  source: AwsContentItem
  ingested?: AwsContentItem
}

// These are all the source file urls paired with the ingested file url
export const pairedFilesAtom = atom(async (get) => {
  const sourceFiles = await get(filteredSourceFilesAtom)
  const ingestedFiles = await get(ingestedFilesAtom)
  return sourceFiles
    .sort(objectFieldSort<AwsContentItem, 'key'>('key'))
    .reduce<PairedFile[]>((acc, source) => {
      const ingested = ingestedFiles.find(({ key }) =>
        key.includes(source.key.split('.')[0]),
      )
      return [...acc, { source, ingested }]
    }, [])
})

export const sourceFilesByUrlAtom = atom<Record<string, IMCourse>>({})
